import { assertUnreachableValue } from '#pplx/frontend/common/type_utils/unreachableValue.js';
/**
 * Calculates one arrow step without changing focus or draft text.
 * `index` is a current row, or `null`/negative when nothing is highlighted.
 * Returns `null` to clear the highlight, or `undefined` to leave native caret movement alone.
 * An unselected above-input menu always leaves ArrowDown to the editor.
 */
export function getNextTypeaheadIndex({ index, count, key, inputEdge, farEdge, above = false, enter = true, }) {
    const currentIndex = index ?? -1;
    const hasNoSelection = currentIndex < 0;
    if (count === 0)
        return above && hasNoSelection ? undefined : null;
    const down = key === 'ArrowDown';
    const towardInput = above ? down : !down;
    if (hasNoSelection) {
        if (!enter || (above && towardInput))
            return undefined;
        if (towardInput && inputEdge === 'release')
            return null;
        return down ? 0 : count - 1;
    }
    const nextIndex = currentIndex + (down ? 1 : -1);
    if (nextIndex >= 0 && nextIndex < count)
        return nextIndex;
    const edge = towardInput ? inputEdge : farEdge;
    switch (edge) {
        case 'wrap':
            return (nextIndex + count) % count;
        case 'clamp':
            return Math.min(Math.max(nextIndex, 0), count - 1);
        case 'release':
            return null;
        default:
            return assertUnreachableValue(edge);
    }
}
//# sourceMappingURL=getNextTypeaheadIndex.js.map